import { render, staticRenderFns } from "./Personeel.vue?vue&type=template&id=27effa1a&"
import script from "./Personeel.vue?vue&type=script&lang=js&"
export * from "./Personeel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports